module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column overflow-auto"
  }, [_c('filter-area', {
    attrs: {
      "resources": _vm.resources,
      "locations": _vm.extractedLocations,
      "categories": _vm.categories,
      "filters": _vm.productFilters,
      "allProducts": _vm.unfilteredProducts
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "mt-4 p-4 text-center"
  }, [_c('loader')], 1) : _c('div', [_c('product-list', {
    attrs: {
      "products": _vm.filteredProducts
    },
    on: {
      "checkAvailability": _vm.checkAvailability
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-653fe339", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-653fe339"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/NewReservation/Search.vue
// module id = 2763
// module chunks = 0